import {CopilotPlan} from '@github-ui/copilot-chat-types'

export function getPlanLabel(plan: string | undefined) {
  switch (plan) {
    case CopilotPlan.IndividualFree:
      return 'Free'
    case CopilotPlan.IndividualMax:
      return 'Max'
    case CopilotPlan.IndividualStudent:
      return 'Student'
    case CopilotPlan.IndividualPro:
      return 'Pro'
    case CopilotPlan.IndividualProPlus:
      return 'Pro+'
    case CopilotPlan.Business:
      return 'Business'
    case CopilotPlan.Enterprise:
      return 'Enterprise'
    default:
      return 'Free'
  }
}
